<template>
    <html>

    <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
        <meta name="mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <link rel="icon" type="image/png" href="favicon.png" />
        <title>Restó APP</title>
    </head>

    <body class="home-page">
        <div class="col-lg-8 mx-auto p-3 py-md-5">
            <main>
                <h3>Modificar Reserva</h3>

                <hr class="" />

                <form v-on:submit.prevent="modificarReserva">
                    <table>
                        <tbody>
                            <tr>
                                <td colspan="2">
                                    <label class="form-label">Restaurante</label>
                                </td>
                                <td>
                                    <input v-model="restaurante.nombre" type="text" class="form-control" disabled />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <label class="form-label">Direccion</label>
                                </td>
                                <td>
                                    <input type="text" v-model="direccion" class="form-control" disabled />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <label class="form-label">Nombre</label>
                                </td>
                                <td>
                                    <input v-model="nombre" type="text" class="form-control" disabled />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <label class="form-label">Apellido</label>
                                </td>
                                <td>
                                    <input v-model="apellido" type="text" class="form-control" disabled />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <label class="form-label">Email</label>
                                </td>
                                <td>
                                    <input v-model="email" type="text" class="form-control" disabled />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <label class="form-label">Teléfono</label>
                                </td>
                                <td>
                                    <input v-model="telefono" type="text" class="form-control" disabled />
                                </td>
                            </tr>
                            <tr style="visibility: hidden">
                                <td>
                                    <label class="form-label">Teléfono</label>
                                </td>
                                <td>
                                    <input type="text" class="form-control" disabled />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <label class="col-sm-3 col-form-label">Comensales</label>
                                </td>
                                <td>
                            <tr>
                                <td>
                                    <label class="form-label">Mayores</label>
                                </td>
                                <td>
                                    <select class="form-control" formControlName="mayores" v-model="cantidad_mayor"
                                        @change="comensales()">
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                    </select>
                                </td>
                                <td>
                                    <label class="form-label">Menores</label>
                                </td>
                                <td>
                                    <select class="form-control" formControlName="menores" v-model="cantidad_menor"
                                        disable="disabled_menores" @change="comensales()">
                                        <option v-for="(menor, index) in menores" :key="index">
                                            {{ menor }}
                                        </option>
                                    </select>
                                </td>
                            </tr>
                            </td>
                            </tr>
                        </tbody>
                    </table>

                    <label class="form-label">Vuelva a elegir la fecha y horario deseado</label>
                    <div class="form-group mb-3">
                        <label class="form-label"> Fecha: </label>
                        <date-picker v-model="fecha" valueType="format" format="DD-MM-YYYY" @change="setHorarios()">
                        </date-picker>
                        <label class="form-label">Horario</label>
                        <vue-timepicker @change="handleTimeChange" v-model="horario" :hour-range="horarios.map(horario => horario.horario)" :minute-interval="15" :minute-range="minutos" :disabled="cantidad_mayor=='' || cantidad_menor==null || fecha==''"></vue-timepicker>
                    </div>
                    <button type="button" class="mb-3 btn btn-danger btn-lg" v-on:click="cancelarReserva">
                        Cancelar Reserva
                    </button>
                    <div class="d-flex justify-content-around">


                        <button type="submit" class="mb-3 btn btn-primary btn-lg" style="">
                            Modificar
                        </button>
                    </div>
                </form>
                <PopUp :show="success" @close="success = false">
                    <template #body>
                        <p>{{ success_msg }}</p>
                    </template>
                </PopUp>
                <PopUp :show="error" @close="error = false">
                    <template #body>
                        <p>{{ error_msg }}</p>
                    </template>
                </PopUp>
                <Footer />
            </main>
        </div>
    </body>

    </html>
</template>

<script>
import axios from "axios";
import PopUp from "../components/PopUp.vue";
import Footer from "../components/Footer.vue";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
    name: "VerReservaManual",
    components: { Footer, PopUp, VueTimepicker, DatePicker },
    data: function () {
        return {
            restaurante: Object,

            direccion: "",
            usuarioNoRegistrado: Object,
            nombre: "",
            reserva_id: "",
            resto_id: "",
            apellido: "",
            email: "",
            telefono: "",
            horario: "",
            horarios: [],
            fecha: "",
            cantidad_mayor: "",
            cantidad_menor: "",
            estado: "",
            menores: [],
            error: false,
            success: false,
            error_msg: "",
            success_msg: "",
            minutos:[],
            token: "",
        };
    },

    methods: {
        handleTimeChange(newValue) {
            this.minutos = this.horarios?.find(h => h.horario == newValue.data.HH)?.minutos;
        },
        comensales() {
        
            console.log(this.horarios);
            if (this.cantidad_mayor != null) {
                this.menores = [];
                this.disabled_menores = false;

                for(let i=0; i <= (6-parseInt(this.cantidad_mayor)); i++){
                    this.menores.push(i);
                }
                if (!this.menores.includes(Number.parseFloat(this.cantidad_menor))) {
                    this.cantidad_menor = null;
                }
            }
        },
        setHorarios() {
            console.log(this.cantidad_mayor);
            console.log(this.cantidad_menor);
            console.log(this.fecha);
            if (
                this.cantidad_mayor != null &&
                this.cantidad_menor != null &&
                this.fecha != null
            ) {
                console.log(this.restaurante);
                axios
                    .get(
                        "/horariosManual/" +
                        this.fecha +
                        "/" +
                        this.cantidad_mayor +
                        "/" +
                        this.cantidad_menor +
                        "/" +
                        this.resto_id
                    )
                    .then((data) => {
                        console.log(data);
                        if (data.data.error == null) {
                            this.horarios = data.data.horarios;
                        } else {
                            this.error = true;
                            this.error_msg = data.data.error;
                            this.disabled_horarios = true;
                        }
                        if (this.horarios.length > 0) {
                            this.disabled_horarios = false;
                        } else {
                            this.disabled_horarios = true;
                            this.error = true;
                            this.error_msg = data.data.error;
                        }
                    });
            } else {
                this.horarios = [];
                this.disabled_horarios = true;
            }
        },
        modificarReserva() {
            if (!confirm("Desea modificar la reserva?")) {
                return;
            }
            this.error_msg = "";
            if (
                this.nombre == "" ||
                this.apellido == "" ||
                this.email == "" ||
                this.telefono == "" ||
                this.horario == "" ||
                this.fecha == ""
            ) {
                this.error = true;
                this.error_msg = "Completa todos los campos por favor";
                return;
            }

            let json = {
                id: this.reserva_id,
                nombre: this.nombre,
                apellido: this.apellido,
                email: this.email,
                telefono: this.telefono,
                fecha: this.fecha,
                horario: this.horario.split(":")[0],
                minutos: this.horario.split(":")[1],
                token: this.token,
                cantidad_mayor: this.cantidad_mayor,
                cantidad_menor: this.cantidad_menor,
                resto_id: this.resto_id,
                usuario_id: this.usuarioNoRegistrado.id,
            };

            axios
                .post("/modificar_reserva_manual", json)
                .then((data) => {
                    if (data.data.error == null) {
                        this.success = true;
                        console.log(data.data.reserva_id);

                        this.success_msg = "Reserva modificada con exito. ";
                    } else {
                        this.error = true;
                        this.error_msg = data.data.error;
                    }
                })
                .catch((e) => {
                    this.error = true;
                    if (e.request.status == 400) {
                        this.error_msg = "No se ha podido modificar la reserva";
                    } else {
                        this.error_msg = "No se ha podido modificar la reserva";
                    }
                });
        },
        cancelarReserva() {
            if (confirm("Desea cancelar la reserva?")) {
                if (this.estado == "Cancelada") {
                    this.error = true;
                    this.error_msg = "La reserva ya ha sido cancelada!";

                    return;
                }
                let json = {
                    id: this.reserva_id,
                    email: this.usuarioNoRegistrado.email,
                    resto_id: this.resto_id,
                    reserva_id: this.reserva_id,
                };
                axios
                    .post("/cancelar_reserva_manual", json)
                    .then((data) => {
                        console.log(data);
                        if (data.status != 200) {
                            this.error = true;
                            this.error_msg =
                                "No se pudo cancelar la reserva. Vuelva a intentar mas tarde";
                        } else {
                            this.success = true;
                            console.log(data.data.reserva_id);

                            this.success_msg = "Reserva cancelada con exito. ";
                        }
                    });
            }
        },
    },
    beforeMount() {
        console.log("buscando reserva")

        if(this.$route.query.token!=undefined && this.$route.query.token!=null){
            this.token = this.$route.query.token;
            axios.get("/getReservaToken/" + this.$route.query.token).then((dataForToken) => {
                console.log("dataForToken",dataForToken)
           axios.get("/getReserva/" + dataForToken.data.id).then((data) => {
            if (data.status == 200) {
                axios.get("/getRestaurantForIdReserva/" + dataForToken.data.id).then((restorIdResponse) => {
                   
                this.resto_id = restorIdResponse.data.restauranteId
                this.reserva_id = data.data.id
                if (data.data.estado.toUpperCase() == "Cancelada".toUpperCase()) {
                    this.error = true;
                    this.error_msg = "La reserva ya ha sido cancelada!";
                }
                this.estado = data.data.estado;
                this.usuarioNoRegistrado = data.data.usuarioNoRegistrado;
                this.nombre = data.data.usuarioNoRegistrado.nombre;
                this.apellido = data.data.usuarioNoRegistrado.apellido;
                this.email = data.data.usuarioNoRegistrado.email;
                this.telefono = data.data.usuarioNoRegistrado.telefono;
                this.cantidad_mayor = data.data.comensales_mayores;
                this.cantidad_menor = data.data.comensales_menores;
                this.fecha = data.data.fecha;
                
                console.log(data.data.horario+":"+data.data.minutos)
                
                this.horarios.push({horario:data.data.horario});
                this.minutos.push(data.data.minutos);
                this.horario = data.data.horario+":"+data.data.minutos;
                axios
                    .get("/restaurante/" + this.resto_id)
                    .then((data) => {
                        if (data.status == 200) {
                            this.restaurante = data.data;
                            this.direccion =
                                data.data.calle +
                                " " +
                                data.data.altura +
                                ", " +
                                data.data.provincia;
                        } else {
                            console.log("hola");
                            this.error = true;
                            this.error_msg =
                                "No se ha podido cargar la informacion del restaurante";
                        }
                    });
                this.comensales();
                });
                


            
            } else {
                console.log("chau");
                this.error = true;
                this.error_msg = "No se ha podido cargar la reserva";
            }
        });

      

        });
        }else{

            axios.get("/getReserva/" + this.reserva_id).then((data) => {
            if (data.status == 200) {
                console.log(data.data.restaurante)
                this.resto_id = data.data.restaurante_id
                this.reserva_id = data.data.id
                if (data.data.estado == "Cancelada") {
                    this.error = true;
                    this.error_msg = "La reserva ya ha sido cancelada!";
                }
                this.estado = data.data.estado;
                this.usuarioNoRegistrado = data.data.usuarioNoRegistrado;
                this.nombre = data.data.usuarioNoRegistrado.nombre;
                this.apellido = data.data.usuarioNoRegistrado.apellido;
                this.email = data.data.usuarioNoRegistrado.email;
                this.telefono = data.data.usuarioNoRegistrado.telefono;
                this.cantidad_mayor = data.data.comensales_mayores;
                this.cantidad_menor = data.data.comensales_menores;
                axios
                    .get("/restaurante/" + this.resto_id)
                    .then((data) => {
                        if (data.status == 200) {
                            this.restaurante = data.data;
                            this.direccion =
                                data.data.calle +
                                " " +
                                data.data.altura +
                                ", " +
                                data.data.provincia;
                        } else {
                            console.log("hola");
                            this.error = true;
                            this.error_msg =
                                "No se ha podido cargar la informacion del restaurante";
                        }
                    });
                this.comensales();
            } else {
                console.log("chau");
                this.error = true;
                this.error_msg = "No se ha podido cargar la reserva";
            }
        });

        axios
            .get("/restaurante/" + this.$route.query.resto_id)
            .then((data) => {
                if (data.status == 200) {
                    this.restaurante = data.data;
                    this.direccion =
                        data.data.calle +
                        " " +
                        data.data.altura +
                        ", " +
                        data.data.provincia;
                } else {
                    console.log("hola");
                    this.error = true;
                    this.error_msg =
                        "No se ha podido cargar la informacion del restaurante";
                }
            });

        }
        
        


       
    },
};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

:root {
    --main-color: #0047b3;
    --second-color: #0198f3;
    --grey-color: #f5f8fa;
    --border-radius-1: 9px;
    --border-radius-2: 6px;
}

body {
    font-family: "Inter", sans-serif;
    color: #083744;
    font-size: 14px;
    height: 100%;
}
</style>
